import './sale-showcase.component.scss'
import { Swiper, Pagination } from 'swiper'
Swiper.use(Pagination)
import { breakpoints } from '../../application/utils/breakpoints'
document.querySelectorAll('.sale-showcase-items').forEach((root) => {
  new Swiper(root.querySelector('.swiper-container'), {
    slidesPerView: 1,
    spaceBetween: 16,
    allowTouchMove: true,
    pagination: {
      el: root.querySelector('.swiper-pagination'),
      clickable: true
    },
    breakpoints: {
      1025: {
        slidesPerView: 3,
        allowTouchMove: false
      },
      [breakpoints.tablet]: {
        slidesPerView: 2,
        allowTouchMove: true
      }
    }
  })
})
